import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  province: 'Buenos Aires',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 3 min'
}, {
  name: 'Carolina S.',
  province: 'Córdoba',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 5 min'
}, {
  name: 'Luciana R.',
  province: 'Mendoza',
  pack: 'MegaPack',
  time: 'hace 8 min'
}, {
  name: 'Alejandra M.',
  province: 'Santa Fe',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 12 min'
}, {
  name: 'Gabriela P.',
  province: 'Tucumán',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 15 min'
}, {
  name: 'Valeria D.',
  province: 'Salta',
  pack: 'MegaPack',
  time: 'hace 18 min'
}, {
  name: 'Romina F.',
  province: 'Entre Ríos',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 22 min'
}, {
  name: 'Florencia G.',
  province: 'Neuquén',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 25 min'
}, {
  name: 'Daniela V.',
  province: 'Chaco',
  pack: 'MegaPack',
  time: 'hace 30 min'
}, {
  name: 'Natalia B.',
  province: 'San Juan',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 35 min'
}, {
  name: 'Soledad K.',
  province: 'Misiones',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 40 min'
}, {
  name: 'Andrea T.',
  province: 'La Plata',
  pack: 'MegaPack',
  time: 'hace 45 min'
}, {
  name: 'Paula C.',
  province: 'Rosario',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 50 min'
}, {
  name: 'Cecilia H.',
  province: 'Mar del Plata',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 55 min'
}, {
  name: 'Silvia N.',
  province: 'Jujuy',
  pack: 'MegaPack',
  time: 'hace 1 hora'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showNext = () => {
    setVisible(true);
    // Hide after 5 seconds
    timerRef.current = setTimeout(() => {
      setVisible(false);
      // Show next one after 10 seconds
      timerRef.current = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        showNext();
      }, 10000);
    }, 5000);
  };
  useEffect(() => {
    if (dismissed) return;
    // First popup after 6 seconds
    timerRef.current = setTimeout(() => {
      showNext();
    }, 6000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dismissed]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
  };
  const current = purchases[currentIndex];
  const isMasterPack = current.pack.includes('Master-Pack');
  if (dismissed) return null;
  return <AnimatePresence data-id="element-258">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-50" data-id="element-259">
          <div className={`relative rounded-2xl p-4 shadow-2xl backdrop-blur-sm ${isMasterPack ? 'bg-gradient-to-r from-navy-800 to-navy-900 border-2 border-gold-500 shadow-[0_0_25px_rgba(234,179,8,0.2)]' : 'bg-navy-800 border border-navy-600'}`} data-id="element-260">
            <button onClick={handleDismiss} className="absolute top-2 right-2 text-slate-500 hover:text-slate-300 p-1" data-id="element-261">
              <X className="w-3.5 h-3.5" data-id="element-262" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-263">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isMasterPack ? 'bg-gold-500/20 text-gold-400' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-264">
                <ShoppingBag className="w-5 h-5" data-id="element-265" />
              </div>

              <div className="min-w-0" data-id="element-266">
                <p className="text-white font-semibold text-sm leading-tight" data-id="element-267">
                  {current.name}
                  <span className="text-slate-400 font-normal" data-id="element-268">
                    {' '}
                    — {current.province}
                  </span>
                </p>
                <p className={`text-sm font-bold mt-0.5 ${isMasterPack ? 'text-gold-400' : 'text-blue-400'}`} data-id="element-269">
                  {isMasterPack ? '🏆 ' : '💙 '}
                  {current.pack}
                </p>
                <p className="text-[11px] text-slate-500 mt-1" data-id="element-270">
                  {current.time} · ✅ Compra verificada
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}